module.exports = __webpack_public_path__ + "static/media/five.545bad2e.ogg";